import { BROADCAST_CHANNEL_TOPIC } from "../const";
import { getRandomKey } from "../utils";
export var Broadcast = /*#__PURE__*/function () {
  function Broadcast() {
    var _this = this;
    this.broadcast = null;
    this.eventBus = {};
    this.handleMap = {};
    var hostTopic = BROADCAST_CHANNEL_TOPIC;
    this.broadcast = new BroadcastChannel(hostTopic);
    // 同一个BroadcastChannel实例发送的message不能被监听到，所以需要重新实例化一个BroadcastChannel
    new BroadcastChannel(hostTopic).onmessage = function (messageEvent) {
      var _messageEvent$data = messageEvent.data,
        event = _messageEvent$data.event,
        data = _messageEvent$data.data;
      if (event) {
        if (_this.eventBus[event]) {
          Object.keys(_this.eventBus[event]).forEach(function (handleId) {
            _this.eventBus[event][handleId](data);
          });
        }
      }
    };
  }
  var _proto = Broadcast.prototype;
  _proto.on = function on(event, callback) {
    if (!this.eventBus[event]) {
      this.eventBus[event] = {};
    }
    var handleId = getRandomKey();
    this.eventBus[event][handleId] = callback;
    this.handleMap[handleId] = event;
    return handleId;
  }

  /** 制造一个事件 */;
  _proto.emit = function emit(event, data) {
    this.broadcast.postMessage({
      event: event,
      data: data
    });
  }

  /** 取消一个订阅，如果传入句柄则取消某一个订阅 */;
  _proto.off = function off(eventOrHandleId) {
    if (this.eventBus[eventOrHandleId]) {
      delete this.eventBus[eventOrHandleId];
    } else {
      var event = this.handleMap[eventOrHandleId];
      if (event) {
        delete this.eventBus[event][eventOrHandleId];
        delete this.handleMap[eventOrHandleId];
      }
    }
  };
  return Broadcast;
}();